import { UserManager } from "oidc-client-ts";
import { keycloakClientId, keycloakViewerClientId } from "../util/constants";
import { logger } from "../util/logger";
import { oidcSettings, viewerOidcSettings } from "./oidcConfig";
type OidcUser = Awaited<ReturnType<typeof userManager.getUser>>;

logger.log("[OIDC] Initializing UserManager", oidcSettings);

export const userManager = new UserManager(oidcSettings);

export const viewerUserManager = new UserManager(viewerOidcSettings);

export const KEYCLOAK_LOGIN_CLIENT_KEY = 'keycloak_login_client';

export const getCurrentClientUserManager = (): {
  userManager: UserManager;
  clientId: string;
} => {
  const client = localStorage.getItem(KEYCLOAK_LOGIN_CLIENT_KEY) ?? 'main';
  if (client === 'viewer') {
    return {
      userManager: viewerUserManager,
      clientId: keycloakViewerClientId ?? '',
    };
  }
  return {
    userManager,
    clientId: keycloakClientId ?? '',
  };
};

export async function getCurrentUser(): Promise<OidcUser> {
  const { userManager: activeUserManager } = getCurrentClientUserManager();
  const user = await activeUserManager.getUser();
  logger.log('[OIDC] getCurrentUser ->', user);
  return user ?? null;
}
